<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-buttons slot="start">
          <ion-back-button default-href="/forms"></ion-back-button>
        </ion-buttons>
        <ion-title v-if="form">{{ form.title }} <span v-if="form && form.pending">(Pending)</span></ion-title>
        <ion-buttons slot="end">
          <ion-button @click="inviteUser" v-if="form && form.pending == false">
            <ion-icon ios="ios-person-add" md="md-person-add"></ion-icon>
          </ion-button>
          <ion-button @click="shareForm" v-if="form && form.pending == false">
            <ion-icon ios="ios-share" md="md-share"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-refresher slot="fixed" @ionRefresh="loadEntries($event)">
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>
      <ion-searchbar type="search" color="light" autocomplete="on" autocorrect="on" placeholder="Search..." :value="search" @ionInput="searchEntries"></ion-searchbar>
      <ion-card color="light" v-if="loading == false && form && entries.length == 0">
        <ion-card-content>
          <h2 class="ion-padding" v-if="form.owner || form.writer">There currently are no entries, <a href="#" @click="createEntry">submit an entry</a> now.</h2>
          <h2 class="ion-padding" v-else>There currently are no entries.</h2>
        </ion-card-content>
      </ion-card>
      <div v-if="loading == false && entries.length > 0">
        <card-entry tappable :entry="entry" :key="index" v-for="(entry, index) in entries" @click.native="showEntry(entry)"></card-entry>
      </div>
      <ion-infinite-scroll threshold="100px" @ionInfinite="moreEntries($event)">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
      </ion-infinite-scroll>
      <ion-fab class="fab" vertical="bottom" horizontal="end" slot="fixed" v-if="form && (form.pending || form.owner || form.writer)">
        <ion-fab-button tappable @click="createEntry">
          <ion-icon ios="ios-create" md="md-create"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    </ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
import Plugins from "../mixins/Plugins";
import User from "../models/User";
import Form from "../models/Form";
import Entry from "../models/Entry";
import Entries from "../models/Entries";
import Value from "../models/Value";
import UserInvite from "./UserInvite.vue";
import FormShare from "./FormShare.vue";
import EntryEdit from "./EntryEdit.vue";
import EntryDetails from "./EntryDetails.vue";
import CardEntry from "../components/CardEntry.vue";
export default {
  name: "form-details",
  components: {
    CardEntry
  },
  mixins: [Helpers, Plugins],
  props: ["id"],
  data() {
    return {
      offset: 0,
      limit: 10,
      search: "",
      loading: false,
      form: null,
      maxRetries: 1,
      entries: new Entries()
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser();
    }
  },
  created() {
    this.loading = true;
  },
  async mounted() {
    let loading = await this.showLoading();
    await this.loadForm();
    await this.loadEntries();
    loading.dismiss();
    this.loading = false;
  },
  destroyed() {},
  methods: {
    async loadForm(event = undefined) {
      this.loading = true;
      try {
        this.form = await Form.restore(this.id);
      } catch (error) {
        this.showWarning(error);
      } finally {
        this.loading = false;
      }
    },
    async loadEntries(event = undefined, retries = 0) {
      try {
        this.offset = 0;
        if (this.form.pending) {
          let entriesPending = await Entries.restore(this.form, this.search, this.offset, this.limit);
          this.entries = entriesPending.sortAsc("ordinal");
        } else {
          if (this.hasConnection()) {
            let entriesLoaded = await Entries.load(this.form, this.search, this.offset, this.limit);
            await entriesLoaded.store();
          }
          let entriesRestored = await Entries.restore(this.form, this.search, this.offset, this.limit);
          this.entries = entriesRestored.sortAsc("ordinal");
        }
      } catch (error) {
        if (this.expiredToken(error) && retries <= this.maxRetries) {
          await this.$store.dispatch("userRefresh");
          await this.loadEntries(event, retries + 1);
        } else {
          this.showWarning(error);
        }
      } finally {
        if (event && event.target) {
          event.target.complete();
        }
        this.loading = false;
      }
    },
    async moreEntries(event = undefined, retries = 0) {
      try {
        this.offset = this.offset + this.limit;
        if (this.hasConnection()) {
          let entriesLoaded = await Entries.load(this.form, this.search, this.offset, this.limit);
          await entriesLoaded.store();
        }
        let entriesRestored = await Entries.restore(this.form, this.search, this.offset, this.limit);
        this.entries = entriesRestored.sortAsc("ordinal");
      } catch (error) {
        if (this.expiredToken(error) && retries <= this.maxRetries) {
          this.offset = this.entries.length;
          await this.$store.dispatch("userRefresh");
          await this.moreEntries(event, retries + 1);
        } else {
          this.showWarning(error);
        }
      } finally {
        if (event && event.target) {
          event.target.complete();
        }
      }
    },
    async searchEntries(event, retries = 0) {
      try {
        this.offset = 0;
        this.search = event.target.value;
        if (this.hasConnection()) {
          let entriesLoaded = await Entries.load(this.form, this.search, this.offset, this.limit);
          await entriesLoaded.store();
        }
        let entriesRestored = await Entries.restore(this.form, this.search, this.offset, this.limit);
        this.entries = entriesRestored.sortAsc("ordinal");
      } catch (error) {
        if (this.expiredToken(error) && retries <= this.maxRetries) {
          await this.$store.dispatch("userRefresh");
          await this.searchEntries(event, retries + 1);
        } else {
          this.showWarning(error);
        }
      }
    },
    async createEntry(event) {
      if (event) {
        event.preventDefault();
      }
      let modal = await this.showModal(EntryEdit, {
        form: this.form
      });
      let dismissed = await modal.onDidDismiss();
      if (dismissed && dismissed.data && dismissed.data.entry) {
        let loading = await this.showLoading();
        await this.loadEntries();
        loading.dismiss();
      }
    },
    async showEntry(entry) {
      await this.showModal(EntryDetails, {
        entry: entry
      });
    },
    async inviteUser() {
      await this.showModal(UserInvite, {
        form: this.form
      });
    },
    async shareForm() {
      await this.showModal(FormShare, {
        form: this.form
      });
    }
  }
};
</script>

<style scoped lang="scss">
a {
  cursor: pointer;
}
h2 {
  color: #888888;
}
</style>
